import { FormEditorTypes } from "@/components/forms/form-editor.config.ts";
import { useFormEditor } from "@/components/forms/form-editor-context.ts";
import usePermissions from "@/hooks/use-permissions.hook.ts";
import { ApiFormElementType } from "@/types/forms/form.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";
import {
  Button,
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuSeparator,
  FontAwesomeIcon,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const AddElementMenu = () => {
  const { t } = useTranslation();
  const {
    formEditorType,
    handleAddElement,
    handleAddScale,
    handleAddGoalScale,
    handleAddSection,
    handleAddPage,
  } = useFormEditor();
  const { isFeatureEnabled } = usePermissions();
  const isGoalsEnabled = isFeatureEnabled(ApiFeatureType.goals);
  const isCustomFieldsEnabled = isFeatureEnabled(ApiFeatureType.custom_fields);
  const isPerformanceReview = [
    FormEditorTypes.performanceReview,
    FormEditorTypes.performanceReviewTemplate,
  ].includes(formEditorType);
  const isSurvey = [FormEditorTypes.surveyTemplate, FormEditorTypes.survey].includes(
    formEditorType
  );

  return (
    <DropdownMenu trigger={<Button variant={"secondary"}>{`${t("common:add")}...`}</Button>}>
      <DropdownMenuItem
        title={t("surveys:question_type_text")}
        description={t("surveys:question_type_text_caption")}
        onClick={() => {
          handleAddElement(ApiFormElementType.text);
        }}
        leftIcon={<FontAwesomeIcon icon="fa-light fa-text-size" />}
      />
      <DropdownMenuItem
        title={t("surveys:question_type_open_answer")}
        description={t("surveys:question_type_open_answer_caption")}
        onClick={() => {
          handleAddElement(ApiFormElementType.open_answer);
        }}
        leftIcon={<FontAwesomeIcon icon="fa-light fa-font-case" />}
      />
      <DropdownMenuItem
        title={t("surveys:question_type_select")}
        description={t("surveys:question_type_select_caption")}
        onClick={() => {
          handleAddElement(ApiFormElementType.select);
        }}
        leftIcon={<FontAwesomeIcon icon="fa-light fa-list-check" />}
      />
      <DropdownMenuItem
        title={t("surveys:question_type_scale")}
        description={t("surveys:question_type_scale_caption")}
        onClick={() => {
          handleAddScale();
        }}
        leftIcon={<FontAwesomeIcon icon="fa-light fa-chart-pyramid" />}
      />
      <DropdownMenuItem
        title={t("surveys:question_type_employee_nps")}
        description={t("surveys:question_type_employee_nps_caption")}
        onClick={() => {
          handleAddElement(ApiFormElementType.employee_nps);
        }}
        leftIcon={<FontAwesomeIcon icon="fa-light fa-comment-smile" />}
      />
      {isSurvey && (
        <DropdownMenuItem
          title={t("surveys:question_type_file")}
          description={t("surveys:question_type_file_caption")}
          onClick={() => {
            handleAddElement(ApiFormElementType.file);
          }}
          leftIcon={<FontAwesomeIcon icon="fa-light fa-paperclip" />}
        />
      )}
      {isGoalsEnabled && isPerformanceReview && (
        <DropdownMenuItem
          title={t("performance_review:question_type_goal")}
          description={t("performance_review:question_type_goal_caption")}
          onClick={() => {
            handleAddGoalScale();
          }}
          leftIcon={<FontAwesomeIcon icon="fa-light fa-bullseye-arrow" />}
        />
      )}
      {isCustomFieldsEnabled && isSurvey ? (
        <>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            title={t("surveys:write_to_field_title")}
            description={t("surveys:write_to_field_caption")}
            onClick={() => {
              handleAddElement(ApiFormElementType.write_to_field);
            }}
            leftIcon={<FontAwesomeIcon icon="fa-light fa-input-text" />}
          />
        </>
      ) : (
        <></>
      )}

      <DropdownMenuSeparator />
      <DropdownMenuItem
        title={t("common:page")}
        description={t("surveys:question_type_page_caption")}
        onClick={() => {
          handleAddPage();
        }}
        leftIcon={<FontAwesomeIcon icon="fa-light fa-file" />}
      />
      <DropdownMenuItem
        title={t("common:section")}
        description={t("surveys:question_type_section_caption")}
        onClick={() => {
          handleAddSection();
        }}
        leftIcon={<FontAwesomeIcon icon="fa-light fa-h1" />}
      />
    </DropdownMenu>
  );
};
